import _pt from "prop-types";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Checkmark = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$ariaHidden = _ref['aria-hidden'],
      ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 18 : _ref$size,
      title = _ref.title,
      titleId = _ref.titleId;
  return ___EmotionJSX("svg", {
    viewBox: "0 0 18 18",
    "aria-hidden": ariaHidden,
    className: className,
    height: size,
    ref: ref,
    role: "img",
    width: size,
    "aria-labelledby": titleId
  }, title === undefined ? ___EmotionJSX("title", {
    id: titleId
  }, 'Checkmark') : title ? ___EmotionJSX("title", {
    id: titleId
  }, title) : null, ___EmotionJSX("path", {
    fill: color,
    d: "M13.746 4.337a1.015 1.015 0 011.409-.099c.417.354.462.97.101 1.378l-7.13 8.047a1.015 1.015 0 01-1.483.03L2.771 9.67a.961.961 0 01.044-1.38 1.015 1.015 0 011.412.041l3.113 3.235 6.406-7.229z",
    fillRule: "evenodd"
  }));
});
Checkmark.propTypes = {
  'aria-hidden': _pt.bool,
  className: _pt.string,
  color: _pt.string,
  size: _pt.oneOf([12, 18, 24]),
  title: _pt.string,
  titleId: _pt.string
};
export default Checkmark;